// extracted by mini-css-extract-plugin
export default {"dialog":"dialog__5hHw5","icon":"icon__PDNOc","title":"title__2GZoX","message":"message__xhz0h","logo":"logo__ZHvcf","action":"action__O+jUq"};